// extracted by mini-css-extract-plugin
export default {"Pagehead":"PanelHeader-module__Pagehead--g9QPZ"};